import axios from 'axios'

export const GET_PLANS = 'GET_PLANS'
export const REGISTER_CUSTOMER = 'REGISTER_CUSTOMER'
export const ANDROID_CUSTOMER = 'ANDROID_CUSTOMER'

const initialState = {
    plans: []
}
export const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    responseType: 'json'
});

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_PLANS:
            return {
                ...state,
                plans: action.payload
            }
        case REGISTER_CUSTOMER:
            return {
                ...state,
                register: action.payload
            }
        case ANDROID_CUSTOMER:
            return {
                ...state,
                android: action.payload
            }
        default:
            return state
    }
}

export const getPlans = () => {
    return async dispatch => {
        let response = await client.request({
            url: "plan",
            method: "GET"
        })
        dispatch({
            type: GET_PLANS,
            payload: response.data.programs
        })
    }
}

export const androidCustomer = (registerState) => {
    let data = Object.assign({}, registerState)

    return async dispatch => {
        let response = await client.request({
            url: "user/android",
            method: "POST",
            data
        })
        if (response.status !== 200) {
            registerState.token = response.data.token
            return response
        } else {
            dispatch({
                type: ANDROID_CUSTOMER,
                payload: response.data
            })
        }
    }
}

export const registerCustomer = (registerState) => {
    let data = Object.assign({}, registerState)

    return async dispatch => {
        let response = await client.request({
            url: "user/register",
            method: "POST",
            data
        })
        if (response.status !== 200) {
            registerState.token = response.data.token
            return response
        } else {
            dispatch({
                type: REGISTER_CUSTOMER,
                payload: response.data
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/planReducer.js